import ReactGA from 'react-ga';
import './googleAnalytics';

export function GAClassroompopup_applyscholarship() {
    ReactGA.event({
        category: 'FormEvent',
        action: 'Click',
        label: 'Classroompopup_applyscholarship'
    });
}

export function GAClassroom_applycourse() {
    ReactGA.event({
        category: 'FormEvent',
        action: 'Click',
        label: 'Classroom_applycourse'
    });
}

export function GAClassroom_applynow() {
    ReactGA.event({
        category: 'FormEvent',
        action: 'Click',
        label: 'Classroom_applynow'
    });
}

export function GAClassroom_syllabus() {
    ReactGA.event({
        category: 'FormEvent',
        action: 'Click',
        label: 'Classroom_syllabus'
    });
}

export function GAAI_fellowship_Form_Submit() {
    ReactGA.event({
        category: 'FormEvent',
        action: 'Click',
        label: 'AI-fellowship-Form-Submit'
    });
}

export function AboutYouApplicationSubmit() {
    ReactGA.event({
        category: 'Breakdown_FormEvent',
        action: 'Click',
        label: 'Aboutyou_continueclick'
    });
}

export function AboutYouApplicationDraft() {
    ReactGA.event({
        category: 'Breakdown_FormEvent',
        action: 'Click',
        label: 'Aboutyou_savedraft'
    });
}

export function PrerequisiteApplicationSubmit() {
    ReactGA.event({
        category: 'Breakdown_FormEvent',
        action: 'Click',
        label: 'Pre-requisite_continueclick'
    });
}

export function PrerequisiteApplicationDraft() {
    ReactGA.event({
        category: 'Breakdown_FormEvent',
        action: 'Click',
        label: 'Pre-requisite_savedraft'
    });
}

export function YourGoalApplicationSubmit() {
    ReactGA.event({
        category: 'Breakdown_FormEvent',
        action: 'Click',
        label: 'Yourgoal_submitted'
    });
}

export function YourGoalApplicationDraft() {
    ReactGA.event({
        category: 'Breakdown_FormEvent',
        action: 'Click',
        label: 'Yourgoal_savedraft'
    });
}

export function GAClassroom_course() {
    ReactGA.event({
        category: 'FormEvent',
        action: 'Click',
        label: 'Classroom_goto_course'
    });
}

export const GAFormEvent = (key: string) => {
  ReactGA.event({
      category: 'FormEvent',
      action: 'Click',
      label: key
  });
}
